
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { AvatarCardVO } from "../../../gamevo/AvatarCardVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Command } from "../Poker2Command";

export class GPVCommand extends Poker2Command {
    protected get cmdId(): string {
        return "gpv";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            var avatarVO: AvatarCardVO = new AvatarCardVO();
            avatarVO.gender = paramObj.gender;
            avatarVO.avatar = Poker2Model.avatarData.parseAvatar(avatarVO.gender, paramObj.allowGiveChips, paramObj.items);
            avatarVO.id = int(paramObj.id);
            //TODO rank client und serverseitig entfernen
            avatarVO.rank = int(paramObj.rank);
            avatarVO.name = paramObj.name;
            avatarVO.level = int(paramObj.level);
            avatarVO.chips = paramObj.chips;
            this.controller.dispatchEvent(new Poker2UserEvent("changePlayerAvatar", [avatarVO, paramObj.viewId]));
            //				layoutManager.showDialog("Poker2RankingAvatarDialog",new Poker2AvatarCardDialogProperties(rankingAvatarVO));
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
